/* ─── Root ─── */

.root {
  font-family: var(--font-sans);
}

/* ─── Item ─── */

.item {
  border-block-end: 1px solid var(--md-outline-variant);
}

.item[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Header ─── */

.header {
  margin: 0;
}

/* ─── Trigger ─── */

.trigger {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
  display: flex;
  align-items: center;
  width: 100%;
  height: 3rem;
  padding-inline: var(--space-4);
  font-family: inherit;
  color: var(--md-on-surface);
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: start;
  position: relative;
}

.trigger::before {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .trigger:hover::before {
    opacity: var(--state-hover);
  }
}

.trigger:focus-visible::before {
  opacity: var(--state-focus);
}

.trigger:active::before {
  opacity: var(--state-pressed);
}

.item[data-disabled] .trigger {
  cursor: not-allowed;
}

.triggerContent {
  flex: 1;
  min-width: 0;
}

/* ─── Chevron ─── */

.chevron {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
  transition: transform var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.trigger[data-panel-open] .chevron {
  transform: rotate(180deg);
}

/* A leading chevron points at its row when closed and down when open. */
.trigger[data-chevron="start"] .chevron {
  margin-inline-end: var(--space-3);
  transform: rotate(-90deg);
}

.trigger[data-chevron="start"][data-panel-open] .chevron {
  transform: rotate(0deg);
}

/* ─── Panel ─── */

.panel {
  height: 0;
  overflow: hidden;
  transition: height var(--motion-duration-medium1)
    var(--motion-easing-standard);
}

.panel[data-open] {
  height: var(--accordion-panel-height);
}

/* ─── Panel content ─── */

.panelContent {
  padding: var(--space-3) var(--space-4) var(--space-4);
}
